import { useCallback } from "react";
import { useController } from "react-hook-form";
import { ControlledTextField } from "@benefit-systems/hr-tools-ui";
import __ from "src/utils/Translations";
import { useTextFieldClearableSupport } from "./useTextFieldClearableSupport";

export const BenefitNameField = () => {
  const { field } = useController({ name: "benefitName" });
  const hasValue = !!field.value;

  const handleClear = useCallback(() => {
    field.onChange(null);
  }, [field]);

  return (
    <ControlledTextField
      name="benefitName"
      label={__("Nazwa benefitu")}
      fullWidth
      margin="none"
      {...useTextFieldClearableSupport(hasValue, handleClear)}
    />
  );
};
